import { Injectable } from '@angular/core';

import { NavigationService } from '@core/services/navigation/navigation.service';

import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class CreditReferencesCommand extends BaseProductCommand {
  readonly type = 'credit-references';
  readonly title = 'Справки';
  readonly icon = 'invoice-list';
  readonly productType = ProductTypes.CREDIT;
  readonly isInfoAction = false;
  readonly settingsNames = undefined;
  readonly order = 4; // Четвертый в actions для credit

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private navigationService: NavigationService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.navigationService.push('credit-references', {
      state: {
        subTitle: 'по действующему кредиту',
        product: context.data,
        actingCredit: true
      }
    });
  }
}
